import Vue from 'vue';
import VueI18n from 'vue-i18n';

import messages, { fallbackLocale } from '@/locales';
import pluralization from '@/locales/pluralization';
import { initLocale } from '@/locales/helpers';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: initLocale(),
  fallbackLocale,
  messages,
  pluralization,
});

export default i18n;
